// Shared cookie and blue/green environment helpers
// Centralizes previously duplicated logic found in useCustomQuery and Analytics components.

export const getCookieValue = (name: string): string | null => {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';')?.shift() || null;
  return null;
};

// Determines the blue/green environment override based on host + cookies.
// Returns null if not applicable.
export const getBlueGreenEnv = (
  host: string,
  isWidget?: boolean
): string | null => {
  if (!host) return null;
  const hostNames = ['uhc.com', 'tpa.com'];
  const containsHostName = hostNames.some((name) => host.includes(name));
  if (!containsHostName) return null;
  // Widgets should not send bgEnv (previous behavior preserved)
  if (isWidget) return null;
  const override = getCookieValue('bgTestingEnv');
  if (
    override &&
    !['null', 'undefined', ''].includes(override.toLowerCase().trim())
  )
    return override;
  const bgParcelsCookie = getCookieValue('bgParcelsCookie');
  if (
    bgParcelsCookie &&
    !['null', 'undefined', ''].includes(bgParcelsCookie.toLowerCase().trim())
  )
    return bgParcelsCookie;

  return null;
};
